import axios from 'axios';
import { Store } from 'vuex';
import VueRouter from 'vue-router';
import { getLocalStorage } from '@/shared/utils/utils';
import { DISPLAY_RIBBON_ON_PROFILES, SPRING_PROFILES_ACTIVE } from '@/constants';

export default class AccountService {
  constructor(private store: Store<any>, private cookie: any, private router: VueRouter) {
    this.init();
  }

  public init(): void {
    const token = this.cookie.get('JSESSIONID') || this.cookie.get('XSRF-TOKEN');
    if (!this.store.getters.account && !this.store.getters.logon && token) {
      this.retrieveAccount();
    }
    this.retrieveProfiles();
  }

  public retrieveProfiles(): void {
    this.store.commit('setRibbonOnProfiles', DISPLAY_RIBBON_ON_PROFILES);
    this.store.commit('setActiveProfiles', SPRING_PROFILES_ACTIVE);
  }

  public retrieveAccount(): void {
    this.store.commit('authenticate');

    const finalRedirectUri = this.cookie.get('finalRedirectUri');
    this.cookie.delete('finalRedirectUri');
    this.cookie.delete('issuer');

    axios
      .get('api/account')
      .then(response => {
        const account = response.data;
        const selectLanguage = getLocalStorage('currentLanguage');
        if (account) {
          this.store.commit('authenticated', account);
          if (!selectLanguage && this.store.getters.currentLanguage !== account.langKey) {
            this.store.commit('currentLanguage', account.langKey);
          }
          if (sessionStorage.getItem('requested-url')) {
            this.router.replace(sessionStorage.getItem('requested-url'));
            sessionStorage.removeItem('requested-url');
            return;
          }
          if (finalRedirectUri && finalRedirectUri !== '/forbidden/' && finalRedirectUri !== '/not-found') {
            this.router.push(finalRedirectUri);
          }
        } else {
          this.store.commit('logout');
          this.router.push({
            name: 'ApplierResidenceCountry'
          });
          sessionStorage.removeItem('requested-url');
        }
        this.store.commit('currentLanguage', this.store.getters.currentLanguage);
      })
      .catch(() => {
        this.store.commit('logout');
      });
  }

  public hasAnyAuthority(authorities: any): boolean {
    if (typeof authorities === 'string') {
      authorities = [authorities];
    }
    if (!this.authenticated || !this.userAuthorities) {
      return false;
    }

    for (let i = 0; i < authorities.length; i++) {
      if (this.userAuthorities.includes(authorities[i])) {
        return true;
      }
    }

    return false;
  }

  public async asyncHasAnyAuthority(authorities: any): Promise<any> {
    return new Promise(resolve => {
      if (typeof authorities === 'string') {
        authorities = [authorities];
      }
      axios
        .get('/api/account')
        .then(response => {
          const account = response.data;
          if (account) {
            if (!this.authenticated || !this.userAuthorities) {
              resolve(false);
            }
            for (let i = 0; i < authorities.length; i++) {
              if (account.authorities.includes(authorities[i])) {
                resolve(true);
              }
            }
            resolve(false);
          }
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  public clearSession() {
    return axios.get('/api/clear-session');
  }

  public get authenticated(): boolean {
    return this.store.getters.authenticated;
  }

  public get userAuthorities(): any {
    return this.store.getters.account.authorities;
  }
}
